import { mmMatches } from '../utils/utils.matchmedia';
import Siema from 'siema';
import debounce from 'lodash/debounce';

let countersInitialised = false;

function countersAreInitialised() {
    return countersInitialised;
}

function activateCounter(index) {
    const statPulloutCounters = document.querySelectorAll('.js-stat-pullout-counter');

    // Remove the 'is-active' class for whichever counter is currently active.
    [...statPulloutCounters].forEach(counter => {
        if(counter.classList.contains('is-active')) {
            counter.classList.remove('is-active');
        }

        // Add 'is-active' class to the slide that we just changed to.
        if(counter.getAttribute('data-controls-slide') == index) {
            counter.classList.add('is-active');
        }
    });
}

function showCounters() {
    if(!countersAreInitialised()) {
        // Grab all the carousel items.
        const statPulloutItems = document.querySelectorAll('.js-stat-pullout-item');

        const statPulloutCountersEl = document.querySelector('.js-stat-pullout-counters');

        // Loop through the slides and create a counter for each slide.
        for (let i = 0; i < statPulloutItems.length; i++) {

            let statPulloutCounter = document.createElement('li');
            statPulloutCounter.classList.add('stat-pullout__counter', 'js-stat-pullout-counter');
            statPulloutCounter.setAttribute('data-controls-slide', i);

            if(i == 0) {
                statPulloutCounter.classList.add('is-active');
            }

            statPulloutCountersEl.appendChild(statPulloutCounter);
        }

        countersInitialised = true;
    }
}

function registerCounterClickEvents(carousel) {
    // Grab all the carousel items.
    const statPulloutCounters = document.querySelectorAll('.js-stat-pullout-counter');

    // Loop through the counters and add an event listener to go to the selected slide.
    [...statPulloutCounters].forEach((counter, i) => {
        counter.addEventListener('click', () => {
            carousel.goTo(i, () => activateCounter(i));
        });
    });
}

function shouldCarouselAtScreenSize( items ) {

    if ( mmMatches('desktop') ) {

        if ( items > 3 ) {

            return true;

        }

    } else if ( mmMatches('desktop-max') && mmMatches('tablet') ) {

        if  ( items > 2 ) {

            return true;

        }

    } else if ( mmMatches('tablet-max') ) {

        if ( items > 1 ) {

            return true;

        }
        
    }

    return false;

}

const statPullout = document.querySelectorAll('.js-stat-pullout');


statPullout.forEach(item => {

    initialiseCarousel( item );

});

function handlePreviousClick(currentSlide, carousel) {
    const   currentSlideIndex = currentSlide,
            nextSlideIndex = currentSlideIndex - 1;

    if ( nextSlideIndex > -1 ) {
        carousel.goTo(nextSlideIndex);
    }
}

function handleNextClick(currentSlide, carouselLength, carousel) {
    const   currentSlideIndex = currentSlide,
            nextSlideIndex = currentSlideIndex + 1;

    if ( nextSlideIndex < carouselLength ) {
        carousel.goTo(nextSlideIndex);
    }
}

function disableButton(button) {
    if(button) {
        button.classList.add('is-disabled');
        button.disabled = true;
    }
}

function enableButton(button) {
    if(button) {
        button.classList.remove('is-disabled');
        button.disabled = false;
    }
}

function itemsPerPage(carousel) {

    if ( mmMatches('desktop') ) {

        return 3;

    } else if ( mmMatches('desktop-max') && mmMatches('tablet') ) {

        return 2;

    } else if ( mmMatches('tablet-max') ) {

        return 1;
        
    }

}

function initialiseCarousel(item) {
    
    const   items = item.children.length,
            carouselNextPrev = document.querySelector('.js-next-prev-buttons'),
            statPulloutCountersEl = document.querySelector('.js-stat-pullout-counters');

    if ( shouldCarouselAtScreenSize( items ) ) {

        const   prevButton = carouselNextPrev.querySelector('.js-prev'),
                nextButton = carouselNextPrev.querySelector('.js-next');

        item.classList.add('is-carousel');

        const carousel = new Siema({
            selector: item,
            duration: 200,
            easing: 'ease-out',
            perPage: {
                0: 1,
                768: 2,
                1024: 3
            },
            startIndex: 0,
            draggable: true,
            multipleDrag: true,
            threshold: 20,
            loop: false,
            onInit: () => {
                showCounters();
                // window.addEventListener('resize', debounce(showCounters, 250));
                disableButton(prevButton);
            },
            onChange: () => {
                activateCounter(carousel.currentSlide);

                if(carousel.currentSlide > 0) {
                    enableButton(prevButton);
                } else {
                    disableButton(prevButton);
                }

                if(carousel.currentSlide + itemsPerPage(carousel) == items) {
                    disableButton(nextButton);
                } else {
                    enableButton(nextButton);
                }
            }
        });

        // Grab all the counters that were created.
        const statPulloutCounters = document.querySelectorAll('.js-stat-pullout-counter');

        // Loop through the counters and add an event listener to go to the selected slide.
        [...statPulloutCounters].forEach((counter, i) => {
            counter.addEventListener('click', () => {
                carousel.goTo(i, () => activateCounter(i));
            });
        });

        carouselNextPrev.classList.remove('is-hidden');
        statPulloutCountersEl.classList.remove('is-hidden');

        registerCounterClickEvents(carousel);
        window.addEventListener('resize', debounce(registerCounterClickEvents, 250));

        window.addEventListener('resize', debounce( function () {
            carousel.destroy(true);

            item.classList.remove('is-carousel');            
        }))

        // Add listeners for arrows
        prevButton.addEventListener('click', function () {
            handlePreviousClick(carousel.currentSlide, carousel)
        });
        
        nextButton.addEventListener('click', function () {
            handleNextClick(carousel.currentSlide, items, carousel)
        });

    } else {

        carouselNextPrev.classList.add('is-hidden');
        statPulloutCountersEl.classList.add('is-hidden');

        if ( item.classList.contains('is-carousel') ) {

            item.classList.remove('is-carousel');

        }

    }

    window.addEventListener('resize', debounce( function () {
        if ( !item.classList.contains('is-carousel') ) {

            initialiseCarousel( item )

        }
    }))

}
